
export class BillingInfo {

  public firstName: string;
  public lastName: string;
  public email: string;
  public phoneNumber: number;
  public state: string;
  public companyName: string;
  public companyVat: string;
  public companyAddressLine1: string;
  public companyAddressLine2: string;
  public companyCountry: string;
  public companyCity: string;
  public companyZipCode: string;

  constructor() {}

}

